import React, { Component, componentDidMount } from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";

class DevInfo extends Component {

    
    componentDidMount() {
        Aos.init({ duration: 700,
            delay:200});
    }
    
    render() {
            return (
            <div className="devinfo" id={this.props.direction}  data-aos="fade-up" data-aos-delay="50">
                <img src={this.props.img}/>
                <div className="devinfo-text">
                    <h1>{this.props.title}</h1>
                    <p>{this.props.text}</p>
                </div>
                
            </div>
        )
    }
}

export default DevInfo
